import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _get from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/image/imageloadobserver
 */
import Observer from '@ckeditor/ckeditor5-engine/src/view/observer/observer';
/**
 * Observes all new images added to the {@link module:engine/view/document~Document},
 * fires {@link module:engine/view/document~Document#event:imageLoaded} and
 * {@link module:engine/view/document~Document#event:layoutChanged} event every time when the new image
 * has been loaded.
 *
 * **Note:** This event is not fired for images that has been added to the document and rendered as `complete` (already loaded).
 *
 * @extends module:engine/view/observer/observer~Observer
 */

var ImageLoadObserver =
/*#__PURE__*/
function (_Observer) {
  _inherits(ImageLoadObserver, _Observer);

  function ImageLoadObserver(view) {
    var _this;

    _classCallCheck(this, ImageLoadObserver);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageLoadObserver).call(this, view));
    /**
     * List of img DOM elements that are observed by this observer.
     *
     * @private
     * @type {Set.<HTMLElement>}
     */

    _this._observedElements = new Set();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImageLoadObserver, [{
    key: "observe",
    value: function observe(domRoot, name) {
      var _this2 = this;

      var viewRoot = this.document.getRoot(name); // When there is a change in one of the view element
      // we need to check if there are any new `<img/>` elements to observe.

      viewRoot.on('change:children', function (evt, node) {
        // Wait for the render to be sure that `<img/>` elements are rendered in the DOM root.
        _this2.view.once('render', function () {
          return _this2._updateObservedElements(domRoot, node);
        });
      });
    }
    /**
     * Updates the list of observed `<img/>` elements.
     *
     * @private
     * @param {HTMLElement} domRoot DOM root element.
     * @param {module:engine/view/element~Element} viewNode View element where children have changed.
     */

  }, {
    key: "_updateObservedElements",
    value: function _updateObservedElements(domRoot, viewNode) {
      var _this3 = this;

      if (!viewNode.is('element') || viewNode.is('attributeElement')) {
        return;
      }

      var domNode = this.view.domConverter.mapViewToDom(viewNode); // If there is no `domNode` it means that it was removed from the DOM in the meanwhile.

      if (!domNode) {
        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = domNode.querySelectorAll('img')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var domElement = _step.value;

          if (!this._observedElements.has(domElement)) {
            this.listenTo(domElement, 'load', function (evt, domEvt) {
              return _this3._fireEvents(domEvt);
            });

            this._observedElements.add(domElement);
          }
        } // Clean up the list of observed elements from elements that has been removed from the root.

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this._observedElements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _domElement = _step2.value;

          if (!domRoot.contains(_domElement)) {
            this.stopListening(_domElement);

            this._observedElements.delete(_domElement);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
    /**
     * Fires {@link module:engine/view/document~Document#event:layoutChanged} and
     * {@link module:engine/view/document~Document#event:imageLoaded}
     * if observer {@link #isEnabled is enabled}.
     *
     * @protected
     * @param {Event} domEvent The DOM event.
     */

  }, {
    key: "_fireEvents",
    value: function _fireEvents(domEvent) {
      if (this.isEnabled) {
        this.document.fire('layoutChanged');
        this.document.fire('imageLoaded', domEvent);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this._observedElements.clear();

      _get(_getPrototypeOf(ImageLoadObserver.prototype), "destroy", this).call(this);
    }
  }]);

  return ImageLoadObserver;
}(Observer);
/**
 * Fired when an <img/> DOM element has been loaded in the DOM root.
 *
 * Introduced by {@link module:image/image/imageloadobserver~ImageLoadObserver}.
 *
 * @see module:image/image/imageloadobserver~ImageLoadObserver
 * @event module:engine/view/document~Document#event:imageLoaded
 * @param {module:engine/view/observer/domeventdata~DomEventData} data Event data.
 */


export { ImageLoadObserver as default };